var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"university-banner"},[_c('img',{staticClass:"universityBannerImg",attrs:{"src":require("assets/images/learn/universityBannerImg.png"),"alt":""}}),_c('div',{staticClass:"bannerContent"},[_c('div',{staticClass:"w11"},[_c('p',[_vm._v("老年大学")]),_c('span',[_vm._v(" 教育养老 以课养心让老年朋友在学习中享受快乐，在快乐中享受充"),_c('br'),_vm._v(" 实晚年的目的 ")])])])])
}]

export { render, staticRenderFns }